import { formatDate } from "@/lib/format";

export const ACTIVE_ST = ["Nový", "V řešení"];
export const DONE_ST = ["Hotovo", "Schváleno"];

const startOfToday = () => { const d = new Date(); d.setHours(0, 0, 0, 0); return d; };
const endOfToday = () => { const d = startOfToday(); d.setHours(23, 59, 59, 999); return d; };
const endOfWeek = () => {
  const d = startOfToday();
  const diff = (7 - d.getDay()) % 7; // days until Sunday
  d.setDate(d.getDate() + diff); d.setHours(23, 59, 59, 999); return d;
};
const dlDate = (t) => (t.deadline ? new Date(t.deadline) : null);
export const isOverdue = (t) => t.deadline && dlDate(t) < startOfToday() && ACTIVE_ST.includes(t.status);
export const isToday = (t) => { if (!t.deadline) return false; const d = dlDate(t); return d >= startOfToday() && d <= endOfToday(); };
// Skupina „Tento týden" (Seznam) — OSTRÉ pásmo zítra až neděle, ať se úkol
// s termínem dnes neobjeví ve dvou skupinách naráz.
const isTomorrowToSunday = (t) => { if (!t.deadline) return false; const d = dlDate(t); return d > endOfToday() && d <= endOfWeek(); };
const isLater = (t) => t.deadline && dlDate(t) > endOfWeek();
// Filtr „Do 7 dní" — od dneška 00:00 do dneška +7 dní (zadání 93/B3).
const within7End = () => { const d = startOfToday(); d.setDate(d.getDate() + 7); d.setHours(23, 59, 59, 999); return d; };
export const isWithin7 = (t) => { if (!t.deadline) return false; const d = dlDate(t); return d >= startOfToday() && d <= within7End(); };

const byDeadlineAsc = (a, b) => (a.deadline || "9999") < (b.deadline || "9999") ? -1 : 1;
export const PRIORITY_RANK = { "Vysoká": 0, "Střední": 1, "Nízká": 2 };
export const byPriorityThenDeadline = (a, b) => {
  const p = (PRIORITY_RANK[a.priority] ?? 1) - (PRIORITY_RANK[b.priority] ?? 1);
  return p !== 0 ? p : byDeadlineAsc(a, b);
};
export const completedAt = (t) => t.completion?.at || t.created_at || "";
// Hotové úkoly (218): nejnověji hotové první, shody podle id sestupně — stejně jako
// server stránkuje GET /tasks/approved, takže se stránky dají napojit bez děr.
export const cmpDoneDesc = (a, b) => {
  const x = completedAt(a), y = completedAt(b);
  if (x !== y) return x < y ? 1 : -1;
  const i = a.id || "", j = b.id || "";
  return i === j ? 0 : i < j ? 1 : -1;
};

// Kanban: pořadí karty ve sloupci si skládá uživatel (zadání 96). Karta při
// puštění dostane hodnotu mezi svými novými sousedy (jeden PATCH). Když sousedé
// mají shodné náhradní pořadí (typicky dvě nezařazené karty), sloupec se
// jednorázově přečísluje se STEP-rozestupy — pak už půlení stačí.
export const STEP = 1000;
export const orderBetween = (above, below) => {
  if (above == null && below == null) return 0;
  if (above == null) return below - STEP;
  if (below == null) return above + STEP;
  return (above + below) / 2;
};
// Náhradní pořadí = dnešní řazení (priorita, pak termín) přepočtené na číslo,
// aby se dalo míchat s ručně nastaveným `order` bez migrace dat.
const DAY = 86400000;
export const effOrder = (t) => {
  if (t.order != null) return t.order;
  const rank = PRIORITY_RANK[t.priority] ?? 1;
  const days = t.deadline ? Math.round(new Date(t.deadline) / DAY) : 99999;
  return rank * 1e7 + days;
};
// Řazení sloupce s deterministickým rozřazením shod (pořadí, pak vznik, pak id),
// aby stejné karty vypadaly stejně před i po přenačtení.
export const byOrder = (a, b) => {
  const d = effOrder(a) - effOrder(b);
  if (d !== 0) return d;
  const ca = a.created_at || "", cb = b.created_at || "";
  if (ca !== cb) return ca < cb ? -1 : 1;
  return (a.id || "") < (b.id || "") ? -1 : 1;
};

// Termín ve tvaru DD.MM.RRRR ↔ ISO (zadání 93/D3). Parsuje i „1.9.2026" a „01092026".
export const isoToCz = (iso) => { if (!iso) return ""; const [y, m, d] = iso.split("-"); return `${+d}.${+m}.${y}`; };
export const czToIso = (s) => {
  s = (s || "").trim();
  if (!s) return "";
  let m = s.match(/^(\d{1,2})\.\s*(\d{1,2})\.\s*(\d{4})$/);
  if (!m) m = s.match(/^(\d{2})(\d{2})(\d{4})$/);
  if (!m) return null;
  const [, d, mo, y] = m;
  return `${y}-${String(mo).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
};

export const NO_PROJECT = "__none__";   // hodnota v Selectu pro „bez zakázky" (Radix nepovolí prázdný string)

// Kanban: sloupce = stavy API, popisky přes STATUS_LABEL (89b). Pořadí = tok práce.
export const KANBAN_COLS = ["Nový", "V řešení", "Hotovo", "Schváleno"];
// Sloupec schválených (popisek „Hotovo“) je historie: nejnovější nahoře a pořadí se v něm
// neskládá (server schválený úkol neupraví). Ostatní sloupce podle ručního pořadí.
export const kanbanSort = (st) => (st === "Schváleno" ? cmpDoneDesc : byOrder);
export const COL_DOT = { "Nový": "bg-muted-foreground", "V řešení": "bg-brand", "Hotovo": "bg-amber-500", "Schváleno": "bg-success" };

// Relativní popisek termínu na kartě/řádku.
export function deadlineLabel(t) {
  if (!t.deadline) return null;
  if (isOverdue(t)) {
    const days = Math.round((startOfToday() - dlDate(t)) / 86400000);
    return { text: `${days} ${days === 1 ? "den" : days >= 2 && days <= 4 ? "dny" : "dní"} po termínu`, cls: "text-destructive font-semibold" };
  }
  if (isToday(t)) return { text: "dnes", cls: "text-amber-500 font-semibold" };
  return { text: formatDate(t.deadline), cls: "text-muted-foreground" };
}

export function groupByDeadline(tasks) {
  const groups = [
    { key: "overdue", label: "Po termínu", danger: true, items: tasks.filter(isOverdue) },
    { key: "today", label: "Dnes", items: tasks.filter((t) => !isOverdue(t) && isToday(t)) },
    { key: "week", label: "Tento týden", items: tasks.filter(isTomorrowToSunday) },
    { key: "later", label: "Později", items: tasks.filter(isLater) },
    { key: "none", label: "Bez termínu", items: tasks.filter((t) => !t.deadline) },
  ].filter((g) => g.items.length > 0);
  groups.forEach((g) => g.items.sort(byPriorityThenDeadline));
  return groups;
}

// 350: Řadit v Seznamu — skupiny podle priority nebo zakázky (výchozí zůstává termín).
const cmpCs = (a, b) => a.localeCompare(b, "cs");
export function groupTasks(tasks, by = "deadline") {
  if (by === "priority") {
    return [["Vysoká", "Vysoká priorita", true], ["Střední", "Střední priorita"], ["Nízká", "Nízká priorita"]]
      .map(([v, label, danger]) => ({ key: `p-${v}`, label, danger, items: tasks.filter((t) => (t.priority || "Střední") === v).sort(byDeadlineAsc) }))
      .filter((g) => g.items.length > 0);
  }
  if (by === "project") {
    const map = new Map();
    tasks.forEach((t) => { const k = t.project_id || ""; if (!map.has(k)) map.set(k, { key: `z-${k || "none"}`, label: t.project_name || "Bez zakázky", items: [] }); map.get(k).items.push(t); });
    const out = [...map.values()].sort((x, y) => (!x.key.endsWith("-none") && y.key.endsWith("-none") ? -1 : x.key.endsWith("-none") && !y.key.endsWith("-none") ? 1 : cmpCs(x.label, y.label)));
    out.forEach((g) => g.items.sort(byPriorityThenDeadline));
    return out;
  }
  return groupByDeadline(tasks);
}

export const DL_OPTS = [
  { v: "all", l: "Vše" }, { v: "overdue", l: "Po termínu" }, { v: "today", l: "Dnes" },
  { v: "next7", l: "Do 7 dní" }, { v: "none", l: "Bez termínu" },
];
export const DL_LABEL = { overdue: "Po termínu", today: "Dnes", next7: "Do 7 dní", none: "Bez termínu" };

// 360: Seznam jako tabulka — záložka Hotové zmizela, čekající na schválení a hotové jsou skupiny na konci.
// groupKey = skupina rozpracovaného úkolu podle Řadit; keyOf (ze stránky) může skupinu „zmrazit“, ať řádek,
// který se právě dokončil nebo schválil, zůstane na místě, dokud je otevřený detail.
export const END_KEYS = ["review", "done"];
export function groupKey(t, by = "deadline") {
  if (by === "none") return "all";
  if (by === "priority") return `p-${t.priority || "Střední"}`;
  if (by === "project") return `z-${t.project_id || "none"}`;
  if (!t.deadline) return "none";
  if (isOverdue(t)) return "overdue";
  if (isToday(t)) return "today";
  if (isTomorrowToSunday(t)) return "week";
  return "later";
}
export const statusKey = (t, by) => (t.status === "Hotovo" ? "review" : t.status === "Schváleno" ? "done" : groupKey(t, by));
// 379: Zobrazení (V) — by = "none" (bez skupin: jedna skupina bez lišty), reverse = skupiny obráceně („Bez termínu“ a
// „Bez zakázky“ zůstávají dole), cmp = Řadit podle uvnitř rozpracovaných. Ke schválení a Hotové vždy na konci, od nejnovějších.
export function taskGroups(tasks, by = "deadline", keyOf = (t) => statusKey(t, by), { reverse = false, cmp } = {}) {
  let defs;
  if (by === "none") defs = [["all", "Rozpracované", false, true]];
  else if (by === "priority") defs = [["p-Vysoká", "Vysoká priorita", true], ["p-Střední", "Střední priorita"], ["p-Nízká", "Nízká priorita"]];
  else if (by === "project") {
    const seen = new Map();
    tasks.forEach((t) => { const k = keyOf(t); if (!END_KEYS.includes(k) && !seen.has(k)) seen.set(k, k === "z-none" ? "Bez zakázky" : t.project_name || "Zakázka"); });
    defs = [...seen.entries()].map(([k, l]) => [k, l]).sort((x, y) => (x[0] === "z-none" ? 1 : y[0] === "z-none" ? -1 : cmpCs(x[1], y[1])));
  } else defs = [["overdue", "Po termínu", true], ["today", "Dnes"], ["week", "Tento týden"], ["later", "Později"], ["none", "Bez termínu"]];
  if (reverse) {
    const bez = (d) => d[0] === "none" || d[0] === "z-none";
    defs = [...defs.filter((d) => !bez(d)).reverse(), ...defs.filter(bez)];
  }
  defs = [...defs, ["review", "Ke schválení"], ["done", "Hotové"]];
  const sortIn = (key) => (END_KEYS.includes(key) ? cmpDoneDesc : cmp || (by === "priority" ? byDeadlineAsc : byPriorityThenDeadline));
  return defs.map(([key, label, danger, flat]) => ({ key, label, danger: !!danger, flat: !!flat, end: END_KEYS.includes(key), items: tasks.filter((t) => keyOf(t) === key).sort(sortIn(key)) }))
    .filter((g) => g.items.length);
}
// Řadit podle (379): priorita (Vysoká = 2), termín, název, vytvořeno; bez hodnoty vždy na konec, při shodě priorita a termín.
const ORDER_VAL = {
  priority: (t) => 2 - (PRIORITY_RANK[t.priority] ?? 1), deadline: (t) => t.deadline || "",
  title: (t) => t.title || "", created: (t) => t.created_at || "",
};
export function taskCmp(k = "priority", dir = "desc") {
  const val = ORDER_VAL[k] || ORDER_VAL.priority, sign = dir === "desc" ? -1 : 1;
  return (a, b) => {
    const va = val(a), vb = val(b);
    if ((va === "") !== (vb === "")) return va === "" ? 1 : -1;
    const c = typeof va === "number" ? va - vb : String(va).localeCompare(String(vb), "cs", { numeric: true });
    return c * sign || byPriorityThenDeadline(a, b);
  };
}
// Kdy byl úkol dokončen — „dnes 9:12“, „včera 16:05“, „12. 10.“
export function doneWhen(t) {
  const iso = t.completion?.at; if (!iso) return "hotovo";
  const d = new Date(iso), day = new Date(d); day.setHours(0, 0, 0, 0);
  const n = Math.round((day - startOfToday()) / 86400000);
  const hm = `${d.getHours()}:${String(d.getMinutes()).padStart(2, "0")}`;
  return `hotovo ${n === 0 ? `dnes ${hm}` : n === -1 ? `včera ${hm}` : `${d.getDate()}. ${d.getMonth() + 1}.`}`;
}
